import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en/en.json";
import itTranslation from "./locales/it/it.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  it: {
    translation: itTranslation,
  },
};

const supportedLanguages = ["it", "en"];

// Get initial language from localStorage, default to 'it'
const getInitialLanguage = () => {
  const storedLang = localStorage.getItem("B2BLanguage");
  // Only accept valid language codes
  if (supportedLanguages.includes(storedLang)) {
    return storedLang;
  }
  // Default to Italian
  return "it";
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getInitialLanguage(), // if you're using a language detector, do not define the lng option
    supportedLngs: supportedLanguages,
    fallbackLng: "it",
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    debug: false,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
